
import React from 'react';
import moment from 'moment'
import jwt_decode from 'jwt-decode';

const Exporter = (records, fetchRelatedRecords) => {
    var com_code=  ((localStorage.token)?jwt_decode(localStorage.token): '???') ? (jwt_decode(localStorage.token)).com_code : '???' 
    var br_code =  ((localStorage.token)?jwt_decode(localStorage.token): '???') ? (jwt_decode(localStorage.token)).branch_code : '???' 
    fetchRelatedRecords(records, 'shipping_date', 'importexports').then(posts => {
       /*  This should come from database
        let data = records.map(record => (
                'X        ' + record.case_no + '  HEM.JAV   ' + record.shipping_case_no + '   ' + record.ucn + '  ' +  (record.ssn).replace(/-/g, '') + '  ' + moment(record.bleed_date).format('MM/DD/YYYY') + '     X       ' + (record.volume).toFixed(3) + '     X    3700175' +'\n'
        ));
        */
        let data = records.map(record => (
            'X        ' + record.case_no + '  '+ com_code + '.' + br_code + '   '  + record.shipping_case_no + '   ' + record.ucn + 
            '  ' +  (record.ssn).replace(/-/g, '') + '  ' + moment(record.bleed_date).format('MM/DD/YYYY') + '     X       ' + (record.volume).toFixed(3) + '     X    3700175' +'\n'
        ));
        data = data.join('');
        
        var blob = new Blob([data], { type: 'text/plain' });
        if(window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveBlob(blob, 'Shipments.' + new Date() + '.txt');
        }
        else{
            var elem = window.document.createElement('a');
            elem.href = window.URL.createObjectURL(blob);
            elem.download = 'shipments.' + new Date() + '.txt';        
            document.body.appendChild(elem);
            elem.click();        
            document.body.removeChild(elem);
        }
        //let textFile = window.URL.createObjectURL(blob);
        //let window2 = window.open(textFile, 'shipments.' + new Date() + '.txt');
        //window2.onload = e => window.URL.revokeObjectURL(textFile);
    });
};

export default Exporter